import { GoogleIcon } from '@nimbus-ds/icons';
import { MenuButton } from '@nimbus-ds/patterns';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { SOCIAL_GOOGLE_ADMIN } from 'App/featuresFlags';
import { useHandleMenuClick, useHasTags } from 'App/hooks';
import goToAdmin from 'commons/utils/gotToAdmin';
import { menuPrimaryGoogleShoppingClick } from './tracking';

const PATHS = {
  google: '/apps/social-google/',
  productFeeds: '/marketing/product_feeds/',
};
const ADMIN_PATH = '/admin';
const HTML_AS_ANCHOR_TAG = 'a';

function GoogleShoppingMenu() {
  const { t } = useTranslation('common');
  const { pathname } = useLocation();
  const { handleClickItem } = useHandleMenuClick();

  const [hasSocialGoogleAdmin] = useHasTags([SOCIAL_GOOGLE_ADMIN]);

  const commonProps = {
    startIcon: GoogleIcon,
    label: `${t('menu.salesChannels.more.google')}`,
  };

  return hasSocialGoogleAdmin ? (
    <MenuButton
      {...commonProps}
      as={Link}
      to={PATHS.google}
      onClick={() => {
        menuPrimaryGoogleShoppingClick();
        handleClickItem();
      }}
      active={pathname === PATHS.google}
    />
  ) : (
    <MenuButton
      {...commonProps}
      as={HTML_AS_ANCHOR_TAG}
      onClick={() => goToAdmin(PATHS.productFeeds)}
      href={`${ADMIN_PATH}${PATHS.productFeeds}`}
    />
  );
}

export default GoogleShoppingMenu;
